import { NgModule } from '@angular/core';
import { PaymentRoutingModule } from './payment-routing.module';
import { MatButtonModule } from '@angular/material/button';
import { provideConfig } from 'core/config';

@NgModule({
  imports: [
    PaymentRoutingModule,
    MatButtonModule
  ],
  providers: [
    provideConfig({
      api: {
        endpoints: {
          csvMappingGet: 'csv-mappings/${mappingType}/${mappingName}',
          csvMappingSave: 'csv-mappings/${mappingType}/${mappingName}',
          csvMappingDelete: 'csv-mappings/${mappingType}/${mappingName}',
          csvMappingList: 'csv-mappings/${mappingType}',
          csvMappingVersions: 'csv-mappings/${mappingType}/${mappingName}/versions',
        },
      },
    }),
  ],
})
export class PaymentModule { }
